import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ActiveEvents, newEvent, toaster } from '../Recoil/ActiveEvents';
import { format } from 'date-fns';

const EventList = () => {
   const [notify, setNotify] = useRecoilState(toaster);
  const [eventID, setEventID] = useRecoilState(newEvent);
  const [activeEvents, setActiveEvents] = useRecoilState(ActiveEvents);
  const navigate = useNavigate();
  const editEventDetails = (event)=>{
    setEventID({evt:event});
    navigate('/createEvent');
  }
  const showRegistredusers = (event) =>{
    setEventID({evt:event});
    navigate('/userView?view=registered');
  }

  const showVolunteerUsers = (event) =>{
    setEventID({evt:event});
    navigate('/userView?view=volunteers');
  }

    useEffect(() => {
      // setCurrentIndex(currIndex.currentIndex)
      let eventURI = process.env.REACT_APP_API_URL +"/Events/GetUpcomingEvents";
      fetch(eventURI , {method: "GET"})
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          let events = !!data.EventsType && !data.EventsType[0].ErrorMessage ? data.EventsType : []
          setActiveEvents(events);
        })
        .catch(error => {
          setNotify({'showPopup': true, 'message':'API failed to get the event details.', type:"error"})
        });
    }, []);

  return <div className='max-w-[1024px] mx-auto px-4 py-12'>
    <div className="flex justify-between">
        <h1 className='text-t-20'>Event Details</h1>
        <button onClick={()=>editEventDetails(null)} className="bg-yellow-600 text-white py-2 px-8 font-medium rounded-md shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75">Create Event</button>
        {/* <Link to="/createEvent" className="bg-yellow-600 text-white py-2 px-8 font-medium rounded-md shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-75">Create Event</Link> */}
    </div>
    <table className="min-w-full table-auto mt-10">
    <thead>
      <tr className="bg-sandel-bg text-orenge">
        <th className="px-4 py-2 text-left">Event Name</th>
        <th className="px-4 py-2 text-left">Event Date</th>
        <th className="px-4 py-2 text-left">Registration End Created</th>
        <th className="px-4 py-2 text-left"></th>
      </tr>
    </thead>
    <tbody>
    {activeEvents.map((item, index) => {
      let evDate = format(item.EventDate, 'dd-MMM-yyyy');
      let regDate = format(item.RegistrationEndDate, 'dd-MMM-yyyy')
       return (
          <tr className="border-b hover:bg-gray-50" key={index}>
            <td className="px-4 py-2">{item.EventName}</td>
            <td className="px-4 py-2">{evDate}</td>
            <td className="px-4 py-2">{regDate}</td>
            <td className="px-4 py-2 text-right">
              <button className="bg-green-bg text-white py-1 px-3 rounded" onClick={()=>editEventDetails(item.EventId)}>Edit</button>
              <button className="bg-red-500 text-white py-1 px-3 rounded ml-2" onClick={()=>showRegistredusers(item.EventId)}>Registred Users</button>
              <button className="bg-blue-600 text-white py-1 px-3 rounded ml-2" onClick={()=>showVolunteerUsers(item.EventId)}>Volunteer Users</button>
              {/* <button className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-700 ml-2">Delete</button> */}
            </td>
          </tr>
        )
        })
      }
      
    </tbody>
  </table>
   
  </div>;
};

export default EventList;